import { LUXURY_PLUS_PATHS } from 'loyalty/constants/base'

const LANDING_PAGE_REGEX = new RegExp(`^\\/[a-zA-Z]+\\/${LUXURY_PLUS_PATHS.LANDING_PAGE}$`, 'i')

export default function isLuxPlusLandingPage(state: App.State): boolean {
  const path = state.router.location?.pathname ?? ''
  return LANDING_PAGE_REGEX.test(path)
}
